exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".article-activity-wrapper .field-textbox{height:36px}.article-activity-wrapper .btn{height:36px;margin:0 10px}.article-activity-wrapper .header-row{font-size:20px;margin-top:20px}.article-activity-wrapper .audit-log{margin-bottom:10px}", ""]);
